// The accounts remembered on this device for quick login (owner 2026-10-03: sisters sharing a device tap their
// avatar on the login screen). Per entry: the player's id, name and look (for the circle) and the device's
// quick-login key from the server — never the password. Storage may be blocked (private mode): then nothing is kept.
const KEY = 'sd_quick_logins';

export function createQuickLogins(storage) {
  const read = () => {
    try { const v = JSON.parse(storage?.getItem(KEY) ?? '[]'); return Array.isArray(v) ? v.filter((e) => e?.player_id && e?.token) : []; }
    catch { return []; }
  };
  const write = (list) => { try { storage?.setItem(KEY, JSON.stringify(list)); } catch { /* blocked */ } };
  return {
    list: read,
    // after a login / register: newest first, one entry per player (a new key replaces the old one)
    remember({ player_id, name, character, quick_token }) {
      if (!player_id || !quick_token) return;
      const prev = read().find((e) => e.player_id === player_id);
      write([{ player_id, name, character, equipped: prev?.equipped ?? null, look: prev?.look ?? null, token: quick_token }, ...read().filter((e) => e.player_id !== player_id)]);
    },
    // the look at logout, so the circle shows her in what she wears now (and her skin / eyes / hair, character look)
    // (a `look` key, even null = back to the default, replaces it; no key keeps it — like the outfit message)
    setLook(player_id, { character, equipped, ...rest }) {
      write(read().map((e) => (e.player_id === player_id
        ? { ...e, character: character ?? e.character, equipped: equipped ?? e.equipped, look: 'look' in rest ? rest.look ?? null : e.look ?? null }
        : e)));
    },
    forget(player_id) {
      const all = read(), gone = all.find((e) => e.player_id === player_id) ?? null;
      write(all.filter((e) => e.player_id !== player_id));
      return gone;
    },
  };
}

export const quickLogins = createQuickLogins(typeof window !== 'undefined' ? window.localStorage : null);
